import { isNativeShell } from './platform.js';

/**
 * "Clique para conversar" do WhatsApp: um endereço `wa.me/<número>?text=<texto>`
 * abre a conversa com a pessoa e o texto já escrito. Quem toca em enviar é o
 * dono, lá dentro. Nada aqui envia, lê ou automatiza coisa alguma.
 */

/** O número só com dígitos e com o código do país (Brasil por padrão), ou null. */
export function whatsappDigits(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  let digits = trimmed.replace(/\D/g, '');
  if (trimmed.startsWith('+') || digits.startsWith('00')) {
    // Já veio com o código do país.
    digits = digits.replace(/^00/, '');
    return digits.length >= 8 && digits.length <= 15 ? digits : null;
  }
  if (digits.length >= 12 && digits.startsWith('55')) {
    return digits.length <= 13 ? digits : null;
  }
  // Número nacional (DDD e 8 ou 9 dígitos), com ou sem o zero da operadora.
  digits = digits.replace(/^0+/, '');
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  return null;
}

/**
 * Assinatura no fim da mensagem pronta. O WhatsApp só aceita emoji do Unicode
 * (não há catálogo de emoji próprio; figurinha é imagem, não entra no texto),
 * então a marca é o "S" circulado (U+24C8), que todo teclado e aparelho mostra.
 * Só a marca, sem frase (pedido do Igor em 23/10): discreta para quem manda e curiosa para
 * quem recebe. Quem manda desliga em "Jeito de falar".
 */
export const WHATSAPP_SIGNATURE = 'Ⓢ';

export function signWhatsApp(text: string, signed: boolean): string {
  const body = text.trim();
  if (!signed || !body || body.endsWith(WHATSAPP_SIGNATURE)) return body;
  return `${body}

${WHATSAPP_SIGNATURE}`;
}

export function whatsappLink(digits: string, text: string): string {
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}

/** Abre a conversa no WhatsApp (fora do app) com a mensagem pronta no campo. */
export function openWhatsApp(digits: string, text: string): void {
  window.open(whatsappLink(digits, text), isNativeShell() ? '_system' : '_blank', 'noopener');
}
